export default __webpack_public_path__ + "static/media/button-share.c193aee5.svg";